module.exports = __webpack_public_path__ + "fonts/Inter-300-latin42.30a274c.woff2";